import Optional from '@acri-tools/react-tools/components/Optional/Optional';
import Select from '@acri-tools/react-tools/components/Select/Select';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import { BYTE_PREFIX } from '../../utils/data';
import { check_request, format_request_data, RequestAOI, RequestPeriod } from '../../utils/requests';
import InputList from '../InputList/InputList';
import RequestForm from '../RequestForm/RequestForm';

import './CreateRequest.css';

interface Props{
    onCreate?: Function
}
interface State{
    creating: boolean

    // Creation 
    type: string
    name: string
    mission: string
    instrument: string
    dataset_id: string
    product_level: string
    volume?: number
    volume_suffix: string
    nb_products?: number

    product_type: Array<string>
    target_products: Array<string>
    filters: Array<string>
    additional_requirements: Array<string>

    period: Array<RequestPeriod>
    aoi: Array<RequestAOI>
}

const default_values = {
    name: '',
    mission: '',
    instrument: '',
    dataset_id: '',
    product_level: '',
    volume: undefined,
    volume_suffix: BYTE_PREFIX[0],
    nb_products: undefined,

}

    // "product_type" jsonb,
    // "target_products" jsonb,
    // "nb_products" int,
    // "filters" jsonb,
    // "period" jsonb,
    // "aoi" jsonb,
    // "additional_requirements" jsonb,



export default class CreateRequest extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            creating: false,
            type: 'service',
            ...default_values,
            product_type: [],
            target_products: [],
            filters: [],
            additional_requirements: [],
        
            period: [],
            aoi: []
        }
    }
    
    render(){
        return (
            <div className="create-request">
                <Optional>*Required</Optional>
                <br/>
                <br/>

                <RequestForm
                    request={this.state}
                    onChange={(updates:any)=>{
                        this.setState(updates);
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.creating
                        })}
                        onClick={this.create}
                    >
                        {
                            this.state.creating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-plus"/> ADD REQUEST</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    create = async() =>{
        let payload:any = { ...this.state };
        delete payload.creating;

        try{
            check_request(payload);
        }
        catch(e:any){
            return create_toast({ type:e.type, message: e.message })
        }

        const array_of_strings = [ 'product_type', 'target_products', 'filters', 'additional_requirements' ];
        for(let arr of array_of_strings){
            if(payload[arr]?.length === 0){
                delete payload[arr];
            }
        }
        format_request_data(payload);

        this.setState({ creating: true })
        try{
            let res = await request(`${API_URL}/api/v1/requests`,{
                method:'post',
                data: payload
            })

            this.props.onCreate?.();
            this.setState({
                ...default_values,
                product_type: [],
                target_products: [],
                filters: [],
                additional_requirements: [],
                period: [],
                aoi: []
            });

            create_toast({ type: 'success', message: `Successfully created request ${res.data.name}` })

            // console.log("this.state", this.state);
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'create'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ creating: false })
        }
    }
};